/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator(), model);
        InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorEcrImageRepositoryNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the ECR image repository name
     */
    starts_with: string;

}
